/**
 * Ô nhập theo bản demo: nhãn viết hoa giãn chữ ở trên, icon dẫn bên trái,
 * nền Navy Nhạt, viền sáng lên Đỏ Sáng khi focus.
 */
import React, { useState } from "react";
import TIcon from "../ui/TIcon";

const FieldInput: React.FC<{
  label: string;
  name: string;
  type?: string;
  icon?: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  error?: string;
  autoComplete?: string;
  /** Khoá ô nhập — dùng cho trường do hệ thống quyết định, ví dụ email của tài
   *  khoản Google. Luôn đi kèm `hint` để người dùng biết vì sao không sửa được. */
  disabled?: boolean;
  /** Câu giải thích dưới ô nhập. Có lỗi thì lỗi hiện thay cho nó. */
  hint?: string;
  /** Dấu tích xanh trong ô — giá trị này đã được hệ thống xác thực. */
  verified?: boolean;
  onChange: (name: string, event: any) => void;
}> = ({
  label,
  name,
  type = "text",
  icon,
  placeholder,
  required = false,
  value,
  error,
  autoComplete,
  disabled = false,
  hint,
  verified = false,
  onChange,
}) => {
  const [reveal, setReveal] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword && reveal ? "text" : type;

  return (
    <div className="field">
      <label htmlFor={name}>
        {label}
        {required ? <span style={{ color: "var(--biadi-red)" }}> *</span> : null}
      </label>

      <div
        className={`input${error ? " error" : ""}`}
        style={disabled ? { opacity: 0.6 } : undefined}
      >
        {icon ? <TIcon name={icon} /> : null}

        <input
          id={name}
          name={name}
          type={inputType}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          onChange={(e) => onChange(name, e)}
        />

        {/* Trước nút hiện/ẩn mật khẩu, nhưng hai thứ này không bao giờ cùng xuất
            hiện: không có ô mật khẩu nào là "đã xác thực". */}
        {verified ? (
          <span className="field-verified" role="img" aria-label="Đã xác thực" title="Đã xác thực">
            <TIcon name="circle-check" />
          </span>
        ) : null}

        {isPassword ? (
          <button
            type="button"
            onClick={() => setReveal((r) => !r)}
            aria-label={reveal ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
            style={{ color: "var(--biadi-muted)", display: "flex" }}
          >
            <TIcon name={reveal ? "eye-off" : "eye"} />
          </button>
        ) : null}
      </div>

      {error ? (
        <span className="field-error">
          <TIcon name="alert-circle" />
          {error}
        </span>
      ) : hint ? (
        <span
          className="tiny"
          style={{ color: "var(--biadi-muted)", marginTop: 6, display: "block" }}
        >
          {hint}
        </span>
      ) : null}
    </div>
  );
};

export default FieldInput;
